<div *ngIf="!mobile">
    <hpo-button id="saveAnimationButton"
        class="save-button"
        type="default"
        color="accent"
        [disabled]="false"
        (click)="saveInfo()">
        <mat-icon [@rotateAnimation]="rotateState">save</mat-icon> {{ 'default.save' | blah }}
    </hpo-button>
    <div *ngIf="clickedAnimation"
        [@fade]="saveButtonState === 'saved' ? 'visibleText' : 'hiddenText'">
        <div *ngIf="!errorState"
            style="color: green;">
            <mat-icon>check</mat-icon>
            <span style="vertical-align: super; padding-left: 5px;">{{ 'default.informationSaved' | blah}}</span>
        </div>
        <div *ngIf="errorState"
            style="color: red;">
            <div style="vertical-align: super; padding-left: 5px;">
                <div>{{ 'default.saveFailedMessage' | blah}}</div>
                <div>{{ 'default.updatePage' | blah}}</div>
            </div>
        </div>
    </div>
    <span *ngIf="animationType === 'rotation' then rotation else saveText">
    </span>
</div>

<div *ngIf="mobile"
    class="mobile-nav">
    <div *ngIf="animationType === 'rotation' then mobileRotation else mobileSaveText">
    </div>
</div>

<ng-template #rotation>
    <span *ngIf="!clickedAnimation"
        [@fade]="saveButtonState === 'saved' ? 'visible' : 'hidden' ">
        <mat-icon style="color: green; vertical-align: middle;">check</mat-icon>
    </span>
</ng-template>

<ng-template #saveText>
    <div *ngIf="showingAnimation"
        [@fade]="saveButtonState === 'saved' ? 'visibleText' : 'hiddenText'"
        style="color: green;">
        <mat-icon>check</mat-icon>
        <span style="vertical-align: super; padding-left: 5px;">{{ 'default.saved' | blah}}</span>
    </div>
</ng-template>

<ng-template #mobileRotation>
    <div class="mobileSave">
        <div *ngIf="!clickedAnimation">
            <div (click)="saveInfo()">
                <mat-icon [@rotateAnimation]="rotateState"
                    style="position: absolute;">save</mat-icon>
                <span [@fade]="saveButtonState === 'saved' ? 'visible' : 'hidden' ">
                    <mat-icon style="color: green; font-size: 18px; position: relative; left: 1.2em; top: 0.5rem">check</mat-icon>
                </span>
            </div>
            <div *ngIf="saveButtonState !== 'saveText'"
                style="font-size: 1.2rem;">{{ 'default.save' | blah}}</div>
        </div>
        <div [@fade]="saveButtonState === 'saved' ? 'visibleMobile' : 'hiddenMobile'">
            <div style="color: green;">
                <mat-icon>check</mat-icon>
                <div style="font-size: 1.2rem;">{{ 'default.saved' | blah}}</div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #mobileSaveText>
    <div class="mobileSave">
        <div *ngIf="!showingAnimation && !clickedAnimation">
            <div (click)="saveInfo()">
                <mat-icon>save</mat-icon>
            </div>
            <div *ngIf="saveButtonState !== 'saveText'"
                style="font-size: 1.2rem;">{{ 'default.save' | blah}}
            </div>
        </div>
        <div [@fade]="saveButtonState === 'saved' ? 'visibleMobile' : 'hiddenMobile'">
            <div *ngIf="!(errorState && clickedAnimation)"
                style="color: green;">
                <mat-icon>check</mat-icon>
                <div style="font-size: 1.2rem;">{{ 'default.saved' | blah}}</div>
            </div>
            <div *ngIf="errorState && clickedAnimation"
                style="color: red;">
                <mat-icon>error</mat-icon>
                <div style="font-size: 1.2rem;">{{ 'default.problems' | blah }}</div>
            </div>
        </div>
    </div>
</ng-template>